import React from 'react'; 
import Helmet from 'react-helmet'; 

const SEO = (props) => (
    <>
        <Helmet>
            <title>Jesús Cortés - Webdev</title>
            <meta name="description" content="Desarrollador Web, ReactJS, Javascript y Bootstrap" />
            <link rel="canonical" href="http://jebusdoodles.github.io" />
            { /* Tags generales */ }
            <title>Jesús Cortés - Webdev</title>
            <meta name="description" content="Desarrollador Web, ReactJS, Javascript y Bootstrap" />
            <link rel="canonical" href="http://jebusdoodles.github.io" />
            { /* Tags de OpenGraph */ }
            <meta property="og:url" content="http://jebusdoodles.github.io" />
            <meta property="og:title" content="Jesús Cortés - Desarrollador Web" />
            <meta property="og:description" content="Desarrollador Web, ReactJS, Wordpress y Bootstrap" />
            { /* Tags de Twitter Card */ }
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Jesús Cortés - Desarrollador Web" />
            <meta property="twitter:description" content="Desarrollador Web, ReactJS, Wordpress y Bootstrap" />
        </Helmet>
    </>
)

export default SEO; 